import { render, staticRenderFns } from "./MembersTransfer.vue?vue&type=template&id=058a0fbb"
import script from "./MembersTransfer.vue?vue&type=script&lang=js"
export * from "./MembersTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports